import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { ArticleOrderDraft, ItemValidationResult } from '../../domain/Order';
import checkIfTwoOrders from './checkIfTwoOrders';
import ValidationResult from './ValidationResult';

interface Props {
    articlesOrdersDrafts: ArticleOrderDraft[];
    itemValidationResult: ItemValidationResult[];
}

class PopupOrdersPlaced extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <>
                <div className="popup-title">Thank you for your order!</div>
                <div className="popup-text">Your order has been placed successfully</div>
                <div className="popup-text">
                    {checkIfTwoOrders(this.props.articlesOrdersDrafts) &&
                        'Your order will be splitted into one order for check-out and one order for stock.'}

                    <div className="popup-button">
                        <NavLink className="link-button" to="/orders-history">
                            See order details >
                        </NavLink>
                    </div>

                    {this.props.itemValidationResult.length > 0 && (
                        <ValidationResult
                            itemValidationResult={this.props.itemValidationResult}
                            label="Unfortunately some items could not be ordered:"
                        />
                    )}
                </div>
            </>
        );
    }
}

export default PopupOrdersPlaced;



// WEBPACK FOOTER //
// ./src/view/popup/PopupOrdersPlaced.tsx